import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MNotification, Text, Flex } from "@cisco/spaces-dash-lib-styleguide";
import { remove } from "../redux/slices/toast.slice";

function ToastCard({ toast, autoCloseTimeout }) {
  const dispatch = useDispatch();
  const autoCloseTimerRef = useRef(null);

  const { id, heading = "", message, options = {} } = toast;

  const {
    banner = true,
    status = "",
    timeout = autoCloseTimeout,
    innerHTML = null,
  } = options;

  const additionalProps = {};
  if (status) {
    additionalProps.status = status;
  }

  const handleClearTimeout = () => {
    if (autoCloseTimerRef.current) {
      clearTimeout(autoCloseTimerRef.current);
    }
  };

  const onClose = () => {
    dispatch(remove(id));
    handleClearTimeout();
  };

  useEffect(() => {
    autoCloseTimerRef.current = setTimeout(
      () => {
        onClose();
      },
      timeout * 60 * 1000,
    );

    return () => {
      handleClearTimeout();
    };
  }, []);

  return (
    <MNotification
      banner={banner}
      onClose={onClose}
      style={{
        width: 400,
      }}
      className="lib-notification-toast-slide"
      {...additionalProps}
    >
      <Flex direction="vertical" gap={4}>
        {heading && <Text weight="bold">{heading}</Text>}
        <Text>{message}</Text>
        {innerHTML}
      </Flex>
    </MNotification>
  );
}

export { ToastCard };
